import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  loading: false,
  success: false,
  error: null,
  sipPlans: [],
  allSipList: [],
  luckyWinner: {},
  luckyWinners: [],
  sipInstallments: [],
  currentPlan: null,
  spinHistory: [],
  runningSips: [],
  sipPlanNames: [],
};

const SipPlanSlice = createSlice({
  name: "sipplan",
  initialState,
  reducers: {
     createSipPlanNullRequest: (state) => {
      //state.loading = true;
      //state.success = false;
      state.error = null;
      state.allSipList = [];
      state.sipInstallments = [];
    },
    createSipPlanRequest: (state) => {
      state.loading = true;
      state.success = false;
      state.error = null;
    },
    createSipPlanSuccess: (state) => {
      state.loading = false;
      state.success = true;
      state.currentPlan = null;
    },
    createSipPlanFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
    fetchSipPlanNamesRequest: (state) => {
      state.loading = true;
      state.success = false;
      state.error = null;
    },
    fetchSipPlanNamesSuccess: (state,action) => {
      state.loading = false;
      state.success = true;
      state.sipPlanNames = action.payload;
    },
    fetchSipPlanNamesFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
    fetchSipPlansRequest: (state) => {
      state.loading = true;
      state.success = false;
      state.error = null;
    },
    fetchSipPlansSuccess: (state, action) => {
      state.loading = false;
      state.success = true;
      state.sipPlans = action.payload.data || [];
      state.total = action.payload.total || 0;
      state.page = action.payload.page || 1;
      state.limit = action.payload.limit || 5;
    },
    fetchSipPlansFailure: (state, action) => {
      state.loading = false;
      state.success = false;
      state.error = action.payload;
    },
    deleteSipPlanRequest: (state) => {
      state.loading = true;
      state.success = false;
      state.error = null;
    },
    deleteSipPlanSuccess: (state, action) => {
      state.loading = false;
      state.success = true;
      state.sipPlans = state.sipPlans.filter(
        (plan) => plan._id !== action.payload
      );
    },
    deleteSipPlanFailure: (state, action) => {
      state.loading = false;
      state.success = false;
      state.error = action.payload;
    },
    changeSipStatusRequest: (state) => {
      state.loading = true;
      state.success = false;
      state.error = null;
    },
    changeSipStatusSuccess: (state, action) => {
      state.loading = false;
      state.success = true;
      const { planid, updatedStatus } = action.payload;
      const planIndex = state.sipPlans.findIndex((plan) => plan._id === planid);
      if (planIndex !== -1) {
        state.sipPlans[planIndex].enabled = updatedStatus;
      }
    },
    changeSipStatusFailure: (state, action) => {
      state.loading = false;
      state.success = false;
      state.error = action.payload;
    },
    setCurrentSipPlan: (state, action) => {
      state.currentPlan = action.payload;
    },
    fetchAllSipListRequest: (state) => {
      state.loading = true;
      state.error = null;
    },

    fetchAllSipListSuccess: (state, action) => {
      state.loading = false;
      state.success = true;
      state.allSipList = action.payload?.data || [];
      state.total = action.payload?.total || 0;
      state.page = action.payload?.page || 1;
      state.limit = action.payload?.limit || 10;
    },

    fetchAllSipListFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
    getSipInstallmentsRequest: (state) => {
      state.loading = true;
      state.error = null;
      state.sipInstallments = [];
    },
    getSipInstallmentsSuccess: (state, action) => {
      state.loading = false;
      state.sipInstallments = action.payload;
    },
    getSipInstallmentsFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
    updateLuckySpinRequest: (state) => {
      state.loading = true;
      state.success = false;
      state.error = null;
    },
    updateLuckySpinSuccess: (state, action) => {
      state.loading = false;
      state.success = true;
      state.luckyWinner = action.payload?.customerData || {};
      state.luckyWinners = action.payload?.winners || [];
    },

    // updateLuckySpinSuccess: (state, action) => {
    //   state.loading = false;
    //   state.success = true;
    //   state.luckyWinner=action.payload;
    // //   state.sipPlans = state.sipPlans.filter(
    // //     (plan) => plan._id !== action.payload
    // //   );
    // },
    updateLuckySpinFailure: (state, action) => {
      state.loading = false;
      state.success = false;
      state.error = action.payload;
    },
    resetLuckySpinState: (state) => {
      state.luckyWinner = null;
      state.luckyWinners = [];
      state.spinHistory = [];
      state.loading = false;
      state.error = null;
      state.success = false;
    },

    fetchSpinHistoryRequest: (state, action) => {
      state.loading = true;
    },
    fetchSpinHistorySuccess: (state, action) => {
      state.loading = false;
      state.spinHistory = action.payload;
    },
    fetchSpinHistoryFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
    //  Fetch Running SIPs
    fetchRunningSipsRequest: (state) => {
      state.loading = true;
      state.error = null;
    },
    fetchRunningSipsSuccess: (state, action) => {
      state.loading = false;
      state.success = true;
      state.runningSips = action.payload || [];
    },
    fetchRunningSipsFailure: (state, action) => {
      state.loading = false;
      state.success = false;
      state.error = action.payload;
    },
    changeLuckyDrawEligibilityRequest: (state) => {
      state.loading = true;
      state.error = null;
    },
    changeLuckyDrawEligibilitySuccess: (state, action) => {
      state.loading = false;
      state.success = true;
      const { sipId, luckyDrawEligibility } = action.payload || {};
      const sipIndex = state.allSipList.findIndex((sip) => sip?._id === sipId);
      if (sipIndex !== -1) {
        state.allSipList[sipIndex].luckyDrawEligibility = luckyDrawEligibility;
      }
    },
    changeLuckyDrawEligibilityFailure: (state, action) => {
      state.loading = false;
      state.success = false;
      state.error = action.payload;
    },

    resetSomethingState: () => initialState,
  },
});

export const {
  createSipPlanNullRequest,
  createSipPlanRequest,
  createSipPlanSuccess,
  createSipPlanFailure,
  fetchSipPlanNamesRequest,
  fetchSipPlanNamesSuccess,
  fetchSipPlanNamesFailure,
  fetchSipPlansRequest,
  fetchSipPlansSuccess,
  fetchSipPlansFailure,
  deleteSipPlanRequest,
  deleteSipPlanSuccess,
  deleteSipPlanFailure,
  changeSipStatusRequest,
  changeSipStatusSuccess,
  changeSipStatusFailure,
  resetSomethingState,
  fetchAllSipListRequest,
  fetchAllSipListSuccess,
  fetchAllSipListFailure,
  getSipInstallmentsRequest,
  getSipInstallmentsSuccess,
  getSipInstallmentsFailure,
  setCurrentSipPlan,
  updateLuckySpinRequest,
  updateLuckySpinSuccess,
  updateLuckySpinFailure,
  resetLuckySpinState,
  fetchSpinHistoryRequest,
  fetchSpinHistorySuccess,
  fetchSpinHistoryFailure,
  fetchRunningSipsRequest,
  fetchRunningSipsSuccess,
  fetchRunningSipsFailure,
  changeLuckyDrawEligibilityRequest,
  changeLuckyDrawEligibilitySuccess,
  changeLuckyDrawEligibilityFailure,
} = SipPlanSlice.actions;

export default SipPlanSlice.reducer;
